<div class="hamburger" #mobileNav><p (click)="showNav.set(true)">&#9776;</p></div>

<nav #navBar [class.show]="showNav()">
  <div class="bg" (click)="showNav.set(false)"></div>

  <div class="page-layout nav-container">
    <img src="/auth/school-admin-logo.png" alt="scientia erp logo">

    <ul>
      @for (link of navLinks; track link.fragment) {
        <li [class.active]="activeFragment() === link.fragment">
          <a (click)="goToFragment(link.fragment)">{{ link.label }}</a>
        </li>
      }
    </ul>

    <button type="button" class="button" routerLink="/login">
      Sign in
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.54004 8.49536H13.4513" stroke-width="1.41589" stroke="white"/>
        <path d="M9.20312 4.24756L13.4508 8.49523L9.20312 12.7429" stroke-width="1.41589" stroke="white"/>
      </svg>

    </button>
  </div>
</nav>

<section class="section-one" id="overview">
  <div class="page-layout">
    <h6>ONE PLATFORM FOR YOUR ENTIRE SCHOOL</h6>

    <h1>Run your school from <br> <span>one clear workspace.</span></h1>

    <p>Manage academics, classes, students, staff, fees and school operations without juggling disconnected spreadsheets and tools.</p>

    <button class="button" type="button" (click)="goToFragment('features')">See what it can do</button>

    <img src="/landing-page/dashboard-overview.png" alt="dashboard overview">

    <div class="summary-features">
      <div>
        <h5>One source</h5>
        <p>FOR SCHOOL RECORDS</p>
      </div>

      <div>
        <h5>Role-based</h5>
        <p>STAFF ACCESS</p>
      </div>

      <div>
        <h5>Real-time</h5>
        <p>OPERATIONAL VISIBILITY</p>
      </div>

      <div>
        <h5>Built-in</h5>
        <p>AUDIT HISTORY</p>
      </div>
    </div>
  </div>
</section>

<section class="section-two" id="features">
  <div class="page-layout">
    <h6>EVERYTHING IN ONE PLACE</h6>

    <h1>Built around the way <br> <span>your school actually works.</span></h1>

    <p>Each module shares the same records, statuses and activity history, so your team can move from overview to action without losing context.</p>

    <div class="main-features">
      @for (f of features; track $index) {
        <div class="feature">
          <div><img src="/landing-page/{{f.img}}" [alt]="f.label"></div>

          <h4>{{ f.label }}</h4>

          <p>{{ f.description }}</p>
        </div>
      }
    </div>
  </div>
</section>

<section class="section-three" id="how-it-works">
  <div class="page-layout">
    <div class="box-one">
      <h6>ACADEMIC FOUNDATION</h6>

      <h1>Set up the school year once, <span>with confidence.</span></h1>

      <p>Define years, terms, levels and subjects in a connected hierarchy. Status cards surface what is active, while guided forms keep every record consistent.</p>

      <ul>
        <li>
          <div>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 6L4.5 8L9.5 3" stroke-width="1.25" stroke="#EFC76F"/>
            </svg>
          </div>

          <p>Create academic structures in minutes</p>
        </li>

        <li>
          <div>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 6L4.5 8L9.5 3" stroke-width="1.25" stroke="#EFC76F"/>
            </svg>
          </div>

          <p>Find any record with search and filters</p>
        </li>

        <li>
          <div>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 6L4.5 8L9.5 3" stroke-width="1.25" stroke="#EFC76F"/>
            </svg>
          </div>

          <p>Keep active and archived data clearly separated</p>
        </li>

      </ul>
    </div>

    <img src="/landing-page/add-level-image.png" alt="adding a level screenshot">

  </div>

  <div class="page-layout">
    <img src="/landing-page/user-mgt-image.png" alt="user management screenshot">

    <div class="box-one">
      <h6>YOUR TEAM, ORGANIZED</h6>

      <h1>Give every staff member <span>the right access.</span></h1>

      <p>Onboard teachers and administrators, filter users by role or status, and manage access through a single dependable directory.</p>
    </div>
  </div>
</section>

<section class="section-four">
  <div class="page-layout">
    <h6>LESS ADMIN, MORE CLARITY</h6>

    <h1>Everything your school <br> needs to stay in control.</h1>

    <p>Open the working dashboard to explore class records, academic setup, user management, fees, assessments and more.</p>

    <div class="rings">
      <div></div>
    </div>
  </div>
</section>

<footer>
  <div class="page-layout">
    <div><img src="/auth/school-admin-logo.png" alt="scientia erp logo"></div>

    <ul>
      <li><a href="https://ianannoh.vercel.app/contact" target="_blank" rel="noopener">Contact us</a></li>
      <li>©{{ currentYear }} Scientia ERP</li>
    </ul>
  </div>
</footer>
